import { Registry } from '@react-registry'

export const video = (el: HTMLElement) => {
  const srcArray = Array.from(el.querySelectorAll("source")).map((source) =>
    source.getAttribute("src")
  );

  return {
    type: 'video',
    attrs: {
      src: srcArray,
    },
    children: [{ text: "" }]
  }
}

Registry.register(video, { id: 'VIDEO', registry: 'deserializer' })